import * as React from "react";
import contract, { Feature, ColorThemeExtras } from "@/utils/contract";
import ContractContext, { initContractStore } from "@/contexts/Contract";

type IUseTheme = {
  isNewTheme?: boolean;
  COLOR_THEME: {
    has: boolean;
    extras?: ColorThemeExtras;
    title?: {
      color?: string;
      background?: string;
    };
    required_icon?: {
      text?: string;
      border?: string;
      background?: string;
    };
  };
};

export const useTheme = (): IUseTheme => {
  const {
    state: { featuresObj },
  } = React.useContext(ContractContext) || initContractStore(contract);
  const isNewTheme = featuresObj[Feature.NEW_DM_WEB_DESIGN]?.enabled;
  const COLOR_THEME_2 = featuresObj[Feature.NEW_DM_WEB_DESIGN]?.color_theme;
  const defaultTheme = "COLOR_THEME";
  const currentTheme = isNewTheme ? COLOR_THEME_2 : defaultTheme;
  let COLOR_THEME: { has: boolean; extras?: ColorThemeExtras } = {
    has: Boolean(featuresObj[currentTheme as string]),
    extras: isNewTheme ? COLOR_THEME_2 : featuresObj[defaultTheme as string]?.color,
  };

  if (isNewTheme) {
    COLOR_THEME = {
      ...COLOR_THEME,
      ...featuresObj[Feature.NEW_DM_WEB_DESIGN],
    };
  }

  return {
    isNewTheme,
    COLOR_THEME,
  };
};
